import React, { useState, useEffect } from 'react';
/* global axios */
import api from '../services/apiService';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const MessageTemplateList = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // **📥 Vorlagen abrufen**
  const fetchTemplates = async () => {
    try {
      const response = await api.get('/messagetemplates');
      setTemplates(response.data);
    } catch (error) {
      console.error('Fehler beim Laden der Vorlagen:', error);
      alert('Fehler beim Laden der Vorlagen.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  // **🗑 Vorlage löschen**
  const handleDeleteTemplate = async (id) => {
    if (window.confirm('Möchten Sie diese Vorlage wirklich löschen?')) {
      try {
        await api.delete(`/messagetemplates/${id}`);
        setTemplates(prev => prev.filter(template => template.id !== id));
        alert('Vorlage erfolgreich gelöscht!');
      } catch (error) {
        console.error('Fehler beim Löschen der Vorlage:', error);
        alert('Fehler beim Löschen der Vorlage.');
      }
    }
  };

  // **✏ Bearbeiten: Weiterleitung zur Bearbeitungsseite**
  const handleEditTemplate = (templateId) => {
    navigate(`/messagetemplates/${templateId}/edit`);
  };

  // **➕ Neue Vorlage erstellen**
  const handleCreateTemplate = () => {
    navigate('/messagetemplates/new');
  };

  if (loading) {
    return <div>Lade Vorlagen...</div>;
  }

  return (
    <div className="template-list" style={{ padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
      <Helmet>
        <title>Vorlagenverwaltung</title>
        <meta name="description" content="Verwalten Sie Ihre E-Mail-Vorlagen" />
      </Helmet>

      <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>E-Mail Vorlagen</h1>

      {/* ➕ Button zum Erstellen einer neuen Vorlage */}
      <button 
        onClick={handleCreateTemplate}
        style={{
          display: 'block',
          margin: '0 auto 20px',
          padding: '10px 15px',
          fontSize: '16px',
          background: '#28a745',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
      >
        + Neue Vorlage erstellen
      </button>

      {/* 📋 Vorlagenliste als Tabelle */}
      {templates.length > 0 ? (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f4f4f4' }}>
              <th style={tableHeaderStyle}>ID</th>
              <th style={tableHeaderStyle}>Name</th>
              <th style={tableHeaderStyle}>Betreff</th>
              <th style={tableHeaderStyle}>Sprache</th>
              <th style={tableHeaderStyle}>In Auswahl</th>
              <th style={tableHeaderStyle}>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {templates.map(template => (
              <tr key={template.id} style={{ textAlign: 'center' }}>
                <td style={tableCellStyle}>{template.id}</td>
                <td style={tableCellStyle}>{template.name}</td>
                <td style={tableCellStyle}>{template.subject}</td>
                <td style={tableCellStyle}>{template.language || 'N/A'}</td>
                <td style={tableCellStyle}>{template.showInMessageSelection === false ? 'Nein' : 'Ja'}</td>

                {/* 📌 Spalte Aktionen */}
                <td style={actionCellStyle}>
                  <button
                    type="button"
                    onClick={() => handleEditTemplate(template.id)}
                    style={editButtonStyle}
                  >
                    Bearbeiten
                  </button>
                  <button
                    type="button"
                    onClick={() => handleDeleteTemplate(template.id)}
                    style={deleteButtonStyle}
                  >
                    Löschen
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p style={{ textAlign: 'center', fontSize: '16px', color: '#777' }}>Keine Vorlagen verfügbar.</p>
      )}
    </div>
  );
};

/* 📌 Style-Objekte für bessere Lesbarkeit */
const tableHeaderStyle = {
  padding: '10px',
  borderBottom: '2px solid #ddd',
  fontSize: '16px',
  fontWeight: 'bold'
};

const tableCellStyle = {
  padding: '10px',
  borderBottom: '1px solid #ddd',
  fontSize: '14px'
};

const actionCellStyle = {
  ...tableCellStyle,
  minWidth: '165px',
  whiteSpace: 'nowrap'
};

const editButtonStyle = {
  fontSize: '14px',
  padding: '5px 10px',
  marginRight: '5px',
  background: '#007bff',
  color: '#fff',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer'
};

const deleteButtonStyle = {
  fontSize: '14px',
  padding: '5px 10px',
  background: '#dc3545',
  color: '#fff',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer'
};

export default MessageTemplateList;
